import { OrganizationData } from "../organization/organization.data.bean";
import { ServiceContractSlot } from "../service/service.contract.slot.bean";

export class GuidedCreation
{
    pharma      : number             ;
    pharmaId    : number             ;
    organization: OrganizationData   ;
    service     : ServiceContractSlot;
    stima       : string | boolean   ;
    customName  : string             ;
    operatorName: string             ;
}